import { Component } from '@angular/core'
import { FooterComponent, HeaderLoggedOutComponent } from '@ftr/ui-core'

@Component({
  selector: 'ftr-app-layout-legacy',
  templateUrl: './app-layout-legacy.component.html',
  styleUrls: ['./app-layout-legacy.component.css'],
  imports: [HeaderLoggedOutComponent, FooterComponent],
})
export class AppLayoutLegacyComponent {}
